import { Component, Inject, OnInit } from '@angular/core';
import { DialogData } from '../../util/notifications/notification.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-m30-download-notice-dialog',
  templateUrl: './m30-download-notice-dialog.component.html',
  styleUrls: ['./m30-download-notice-dialog.component.scss']
})
export class M30DownloadNoticeDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit(): void {
  }

}
